if (!customElements.get('soft-toy-toggle')) {
  customElements.define(
    'soft-toy-toggle',
    class SoftToyToggle extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.section;
        this.packOptionIndex = parseInt(this.dataset.packOptionIndex, 10);
        this.form = document.getElementById(this.dataset.formId);
        this.inputs = Array.from(this.querySelectorAll('input[type="radio"]'));
        this.yesInput = this.inputs.find((input) => input.id.startsWith('SoftToyYes'));
        this.noInput = this.inputs.find((input) => input.id.startsWith('SoftToyNo'));
        this.errorMessage = this.querySelector('.soft-toy-toggle__error');
      }

      connectedCallback() {
        // Was "No" pre-selected for us (server-rendered digital state) rather than
        // clicked by the customer? Tracked so switching to a physical variant only
        // clears an auto-answer, never a real choice the customer already made.
        this.noWasAutoSelected = !!(this.noInput?.checked && this.yesInput?.disabled);

        this.unsubscribeVariantChange = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );
        this.inputs.forEach((input) =>
          input.addEventListener('change', () => {
            this.noWasAutoSelected = false;
            this.clearError();
          })
        );

        this.boundHandleSubmit = this.handleSubmit.bind(this);
        // Listen on the capture phase so this runs before product-form's own
        // submit handler, which calls stopPropagation and adds to cart via fetch.
        document.addEventListener('submit', this.boundHandleSubmit, { capture: true });
      }

      disconnectedCallback() {
        this.unsubscribeVariantChange?.();
        document.removeEventListener('submit', this.boundHandleSubmit, { capture: true });
      }

      handleVariantChange({ data: { sectionId, variant } }) {
        if (sectionId !== this.sectionId) return;
        const isPhysical = Number.isInteger(this.packOptionIndex) && variant?.options?.[this.packOptionIndex] === 'Physical';
        this.setYesAvailability(isPhysical);
      }

      setYesAvailability(isPhysical) {
        this.hidden = !isPhysical;

        if (!this.yesInput) return;
        this.yesInput.disabled = !isPhysical;

        if (!isPhysical) {
          // A soft toy is never possible on a digital variant: don't leave Yes
          // checked (mirrors the Bronze/Physical disable behaviour), and answer
          // "No" automatically rather than making the customer select it.
          this.yesInput.checked = false;
          if (this.noInput) this.noInput.checked = true;
          this.noWasAutoSelected = true;
          this.clearError();
        } else if (this.noWasAutoSelected && this.noInput) {
          // Coming back from a digital auto-answer: clear it so the customer
          // is forced to make a real choice now that Yes is available again.
          this.noInput.checked = false;
          this.noWasAutoSelected = false;
        }
      }

      handleSubmit(event) {
        if (!this.form || event.target !== this.form) return;
        if (this.inputs.some((input) => input.checked)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.showError();
        this.inputs.find((input) => !input.disabled)?.focus();
      }

      showError() {
        this.errorMessage?.removeAttribute('hidden');
      }

      clearError() {
        this.errorMessage?.setAttribute('hidden', '');
      }
    }
  );
}
